module.exports = __webpack_public_path__ + "static/DarksideDetective2-b18fe5411fceb2b5ae29cda4b7ce1895.png";